import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Menu, Icon } from 'semantic-ui-react';
import i18next from 'i18next';
import { hasLoyaltyPermission } from '../../helpers/permissions';

const LoyaltyMenuItems = ({ iconOnly, loyaltyProgramId, match, location }) => {
    const pathname = `/loyaltyProgram/${loyaltyProgramId}`;

    function renderDetailsMenuItem() {
        const title = i18next.t('navDetailsTitle');
        const active = location.pathname === pathname;

        return (
            <Menu.Item key="details" as={Link} active={active} to={pathname} name={title}>
                <Icon name='info circle' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderRestaurantsMenuItem() {
        if (!hasLoyaltyPermission('restaurants')) return null;

        const title = i18next.t('restaurants');
        const active = location.pathname.startsWith(pathname + '/restaurants');

        return (
            <Menu.Item key="restaurants" as={Link} active={active} to={pathname + '/restaurants'}>
                <Icon name='food' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderMembersMenuItem() {
        if (!hasLoyaltyPermission('members')) return null;

        const title = i18next.t('loyaltyProgram.members');
        const active = location.pathname.startsWith(pathname + '/members');

        return (
            <Menu.Item key="members" as={Link} active={active} to={pathname + '/members'}>
                <Icon name='users' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderCampaignsMenuItem() {
        if (!hasLoyaltyPermission('campaigns')) return null;

        const title = i18next.t('loyaltyProgram.campaigns');
        const active = location.pathname.startsWith(pathname + '/campaigns');

        return (
            <Menu.Item key="campaigns" as={Link} active={active} to={pathname + '/campaigns'}>
                <Icon name='line graph' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderPersonalBenefitsMenuItem() {
        if (!hasLoyaltyPermission('benefits')) return null;

        const title = i18next.t('loyaltyProgram.personalBenefits');
        const active = location.pathname.startsWith(pathname + '/personalBenefits');

        return (
            <Menu.Item key="personalBenefits" as={Link} active={active} to={pathname + '/personalBenefits'}>
                <Icon name='money' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderGlobalBenefitsMenuItem() {
        if (!hasLoyaltyPermission('benefits')) return null;

        const title = i18next.t('loyaltyProgram.globalBenefits');
        const active = location.pathname.startsWith(pathname + '/globalBenefits');

        return (
            <Menu.Item key="globalBenefits" as={Link} active={active} to={pathname + '/globalBenefits'}>
                <Icon name='percent' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    return (
        <Fragment>
            {renderDetailsMenuItem()}
            {renderRestaurantsMenuItem()}
            {renderMembersMenuItem()}
            {renderCampaignsMenuItem()}
            {renderPersonalBenefitsMenuItem()}
            {renderGlobalBenefitsMenuItem()}
        </Fragment>
    );
};

LoyaltyMenuItems.propTypes = {
    loyaltyProgramId: PropTypes.string,
    
    match: PropTypes.any,
    location: PropTypes.any,
    iconOnly: PropTypes.bool,
};

export default LoyaltyMenuItems;
